import { ReactElement } from 'react';
import { Grid, ThemeUIStyleObject } from 'theme-ui';
import { breakpoints } from '~/gatsby-plugin-theme-ui/old-theme';
import { OptionalImageIcon } from './sharedTypes';
import { RichImageComponent } from './RichImageComponent';
import { TextX, TextY } from '~/types/style';

type ImageGridProps = {
  richImages: Queries.RichImageFragmentFragment[];
  textY: TextY;
  textX: TextX;
  textXMobile: TextX;
  textYMobile: TextY;
  hover: Queries.HoverEffect;
  optionalImageIcon?: OptionalImageIcon;
};

export const ImageGridDynamicComponent = (props: ImageGridProps): ReactElement => {
  const { richImages, textX, textY, textXMobile, textYMobile, hover, optionalImageIcon } = props;

  const length = richImages.length;

  const expandedCells = length % 4 === 0 ? 0 : 4 - (length % 4);
  const expandedCellsMobile = length % 2 === 0 ? 0 : 2 - (length % 2);

  const mdQueryMobile = `@media screen and (max-width: ${breakpoints[0] - 1}px)`;
  const mdQueryDesktop = `@media screen and (min-width: ${breakpoints[0]}px)`;

  const expandedStyle: ThemeUIStyleObject = {
    gridColumn: 'span 2',
    ':before': {
      paddingTop: ['calc((216/390)*100%)', 'calc((364/667)*100%)'],
    },
  };

  return (
    <Grid
      data-testid="image-grid-dynamic"
      sx={{
        justifyItems: 'stretch',
        gap: ['3xs', null, '3md'],
        gridTemplateColumns: ['repeat(2, 1fr)', 'repeat(4, 1fr)'],
        gridTemplateRows: 'auto',
        height: '100%',
        width: '100%',
        mx: 'auto',
        maxWidth: 'var(--max-width)',
      }}
    >
      {richImages.map((richImage, index, array) => {
        const expandedDesktop = expandedCells > 0 && index >= array.length - expandedCells;
        const expandedMobile = expandedCellsMobile > 0 && index >= array.length - expandedCellsMobile;

        if (richImage === null || !!!richImage?.primaryImage) return null;
        const imageVariantDesktop = expandedDesktop ? 'secondary' : 'primary';
        const imageVariantMobile = expandedMobile ? 'secondary' : 'primary';
        return (
          <RichImageComponent
            key={richImage.id}
            richImage={richImage}
            mode="manual"
            variantImage={[imageVariantMobile, imageVariantDesktop, imageVariantDesktop]}
            hover={hover}
            textY={textY}
            textX={textX}
            textYMobile={textYMobile}
            textXMobile={textXMobile}
            optionalImageIcon={optionalImageIcon}
            forwardSx={{
              '::before': {
                content: '""',
                paddingTop: ['calc((216/191) * 100%)', 'calc((364/322)*100%)'],
                visibility: 'hidden',
              },
              [mdQueryMobile]: {
                ...(expandedMobile && expandedStyle),
              },
              [mdQueryDesktop]: {
                ...(expandedDesktop && expandedStyle),
              },
            }}
          />
        );
      })}
    </Grid>
  );
};
